import script from "./ThesisAssistant.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThesisAssistant.vue?vue&type=script&setup=true&lang=ts"

import "../style/ThesisAssistant.css?vue&type=style&index=0&id=57c7142d&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c7142d"]])

export default __exports__